function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_18_23140)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 15.0191,
  y: 14.1396,
  width: 1.96185,
  height: 15.746,
  rx: 0.980925,
  fill: "#A69AAD"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15.0191,
  y: 14.1396,
  width: 1.96185,
  height: 15.746,
  rx: 0.980925,
  fill: "url(#paint0_linear_18_23140)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15.0191,
  y: 14.1396,
  width: 1.96185,
  height: 15.746,
  rx: 0.980925,
  fill: "url(#paint1_radial_18_23140)"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 10.0056,
  r: 8.03224,
  fill: "url(#paint2_radial_18_23140)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 10.0056,
  r: 8.03224,
  fill: "url(#paint3_radial_18_23140)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 10.0056,
  r: 8.03224,
  fill: "url(#paint4_radial_18_23140)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 10.0056,
  r: 8.03224,
  fill: "url(#paint5_radial_18_23140)"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 18.7371,
  cy: 6.94502,
  rx: 2.06395,
  ry: 2.57531,
  transform: "rotate(-37.6469 18.7371 6.94502)",
  fill: "url(#paint6_linear_18_23140)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_18_23140)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 18.4965,
  width: 0.603327,
  height: 10.5228,
  rx: 0.301664,
  fill: "url(#paint7_linear_18_23140)"
}));

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_18_23140",
  x: 15.0191,
  y: 14.1396,
  width: 2.21185,
  height: 16.496,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.25,
  dy: 4.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.552941 0 0 0 0 0.447059 0 0 0 0 0.584314 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_23140"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_18_23140",
  x: 15.5,
  y: 17.9965,
  width: 1.60333,
  height: 11.5228,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_18_23140"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_23140",
  x1: 17.7754,
  y1: 27.2358,
  x2: 16.3231,
  y2: 27.2358,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C6BECB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C6BECB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_18_23140",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16 22.0126) rotate(90) scale(7.87299 3.70264)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.899673,
  stopColor: "#9F7BBF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9F7BBF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_18_23140",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.8711 13.9358) rotate(-156.453) scale(12.1178 17.416)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD2C8D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA356F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_18_23140",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.3551 10.0056) rotate(-180) scale(11.3873 15.6783)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.434073,
  stopColor: "#CD284F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.948696,
  stopColor: "#A73C52"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_18_23140",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16 6.29208) rotate(90) scale(12.0261)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.690678,
  stopColor: "#CC2272",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB438D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_18_23140",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.3551 7.61699) rotate(130.601) scale(4.69808 4.41886)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5EA3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5EA3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_18_23140",
  x1: 20.0541,
  y1: 5.23778,
  x2: 18.3681,
  y2: 9.31109,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFFDFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_18_23140",
  x1: 16.3017,
  y1: 18.4965,
  x2: 16.3017,
  y2: 29.0193,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDAFC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C3B8CE"
})));

function SvgRoundPushpin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPushpin);
export default __webpack_public_path__ + "static/media/round-pushpin.ba74f945.svg";
export { ForwardRef as ReactComponent };